import { makeStorageHook } from "./makeStorageHook";

export const useLocalStorage = makeStorageHook(window.localStorage);
